import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const WaterHeatersPage = () => <ServicePageTemplate data={servicePageData['water-heaters']} />;
export default WaterHeatersPage;
